<template>
    <div style="width: 100%;height:100%;">
<!--      <img style="position: absolute " :src="require('../../../assets/user_system/login_bg_img.jpeg')" width="100%" height="100%" alt="" />-->

      <!--背景视频-->
      <video style="position:absolute;width:100%;height:100%;object-fit:cover;" autoplay loop muted>
        <source src="https://market.obs.cn-north-4.myhuaweicloud.com:443/202405220957000598264.mp4" type="video/mp4" />
      </video>

      <v-layout row style="position: absolute;left: 25px;top: 25px">
        <v-img contain src="../../../assets/user_system/logoAndTitleNew.png" style="width:200px;flex:none;"></v-img>
      </v-layout>
      <div style="width: 400px;height: 525px;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)">
<!--        <div style="width: 100%;height: 75px;">-->
<!--          <v-img contain src="../../../assets/user_system/earth_login_header_logo.jpg" width="170" height="45" style="float: left;margin-top: 15px;margin-left: 15px"></v-img>-->
<!--          <div style="line-height: 75px;font-size: 20px;color:black;letter-spacing: 2px;font-weight: 400">&nbsp;&nbsp;/&nbsp;&nbsp;让遥感走进生活</div>-->
<!--        </div>-->
        <!--扫码绑定或登录card-->
        <v-card v-show="currentCard === 'loginCard'" class="card">
          <div style="height: 24px;">
            <div style="color:rgba(0, 0, 0, 1);font-size: 24px;float: left;line-height: 24px;font-weight: 400;">欢迎使用</div>
            <div @click="changeLoginWay" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 24px">{{loginWay === "qrCode"?"账号登录":"返回扫码登录"}}</div>
          </div>
          <!--内容-->
          <!--二维码登录-->
          <div v-show ="loginWay === 'qrCode'">
            <div style="width: 180px;height: 180px;margin: 67px auto 35px auto;">
              <!--二维码-->
              <div ref="qrCode" style="width: 180px;height: 180px;position: absolute;"></div>
              <!--扫码成功蒙层-->
              <div v-show="scanSuccess" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                <div style="width: max-content;height: 40px">
                  <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>     <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">扫码成功</div>
                </div>
              </div>
              <!--二维码失效蒙层-->
              <div v-show="qrCodeExpired" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
                <div style="width: max-content;height: 40px">
                  <div style="font-size: 16px;line-height: 40px;margin-left: 5px">二维码已过期</div>
                  <div @click="generateQRCode" style="font-size: 16px;line-height: 40px;margin: 0 auto;width: max-content;color: rgba(25, 118, 210, 1);cursor: pointer">点击刷新</div>
                </div>
              </div>

            </div>
            <div style="color:rgba(166, 166, 166, 1);font-size: 14px;margin: 0 auto;width: fit-content">{{qrHintText}}</div>
            <div style="color:rgba(166, 166, 166, 1);font-size: 14px;margin: 100px auto 0 auto;width: max-content">登录/注册即同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
          </div>
          <!--验证码登录-->
          <div v-show ="loginWay === 'verificationCode'" style="width: 283px;margin: 0 auto">
            <!--手机号-->
            <v-form class="pt-15"
                    ref="phoneLoginForm"
                    v-model="isLoginMsgValid">
              <v-text-field
                  placeholder="请输入手机账号"
                  v-model="phoneNum"
                  :rules = "phoneRule"
                  required>
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入正确的手机格式</div>
                </template>
                <template v-slot:prepend-inner>
                  <div @click.stop="showPhoneCode = true"  style="cursor: pointer;">
                    <div style="width: fit-content;line-height: 25px;color:black;float: left" >+{{prefix}}</div>
                    <v-icon color="black">mdi-menu-down</v-icon>
                  </div>
                </template>
              </v-text-field>
            </v-form>
            <input-pic-captcha :prefix="prefix" :phone="phoneNum"></input-pic-captcha>
            <v-text-field
                @input="onLoginCodeChanged"
                placeholder="请输入手机验证码"
                autocomplete="off"
                v-model="verificationCode"
                class="input-group--focused"
                :rules = "requiredRule"
                border="none">
              <template v-slot:message>
                <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;验证码不能为空</div>
              </template>
              <template v-slot:append>
                <div  @click="sendMsg(phoneNum)" style="width: max-content;cursor: pointer;padding-top: 5px;padding-right: 1px" :style="{color:sendingAvailable ?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
              </template>
            </v-text-field>

            <div v-show="loginVerifyCodeLock" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px;text-align:right;" >操作频繁，请1分钟后再试</div>
            <div v-show="loginVerifyCodeError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码有误，请重新输入</div>
            <div class="d-flex mt-5" style="height: 20px;">
              <v-checkbox
                  class="mt-0 mr-4"
                  style="zoom: 70%;width: 10px;height: 20px;"
                  v-model="privacyCheckboxForLogin">
              </v-checkbox>
              <div style="color:rgba(166, 166, 166, 1);font-size: 14px;width: fit-content">我已阅读并同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
            </div>
            <v-btn
                @click="loginByPhone"
                width="283px"
                height="40px"
                depressed
                :color="phoneLoginBtnClickable ? 'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
                style="margin-top: 30px;color: white;font-size: 16px">
              登录/注册</v-btn>
            <div @click="changeLoginWayBottom" style="height: 16px;margin-top: 30px;color: #A6A6A6FF;font-size: 16px;text-align: center;cursor: pointer">
              密码登录
            </div>
          </div>
          <!--区号-->
          <phone-code class="phoneCode" v-show="showPhoneCode" @selectPhoneCode="selectPhoneCode"></phone-code>
          <!--密码登录-->
          <div v-show ="loginWay === 'account'" style="width: 283px;margin: 0 auto">
            <!--账号-->
            <v-form class="pt-15"
                    ref="loginForm"
                    v-model="isLoginMsgValid">
              <v-text-field
                  placeholder="请输入共生地球账号"
                  v-model="loginAccount"
                  :rules = "requiredRule"
                  required>
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;账号不能为空</div>
                </template>
              </v-text-field>
              <v-text-field
                  placeholder="请输入密码"
                  v-model="loginPassword"
                  :append-icon="showLoginPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showLoginPassword ? 'text' : 'password'"
                  class="input-group--focused"
                  :rules="requiredRule"
                  @click:append="showLoginPassword = !showLoginPassword">
                <template  v-slot:message style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;密码不能为空</template>
              </v-text-field>
            </v-form>
            <div v-show="loginVerifyCodeError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;你输入的账号或密码不正确，请重新输入</div>
            <div class="d-flex mt-5" style="height: 20px;">
              <v-checkbox
                  class="mt-0 mr-4"
                  style="zoom: 70%;width: 10px;height: 20px;"
                  v-model="privacyCheckboxForLogin">
              </v-checkbox>
              <div style="color:rgba(166, 166, 166, 1);font-size: 14px;width: fit-content">我已阅读并同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
            </div>            <v-btn
                @click="loginEvent"
                width="283px"
                height="40px"
                depressed
                :color="loginBtnClickable?'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
                style="margin-top: 30px;color: white;font-size: 16px">
              登录</v-btn>
            <div style="height: 16px;margin-top: 22px">
              <div @click="goToRegister" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: left;line-height: 16px;font-weight: 400;">立即注册</div>
              <div @click="gotoRetrievePassword" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 16px">忘记密码</div>
            </div>
            <div @click="changeLoginWayBottom" style="height: 16px;margin-top: 50px;color: #A6A6A6FF;font-size: 16px;text-align: center;cursor: pointer">
              验证码登录
            </div>
          </div>
        </v-card>
        <Vcode :show="showPicVerify" @success="onPicVerifySuccess" @close="closePicVerify" successText="验证成功！"
               failText="验证失败，请重试！"/>
        <!--注册card-->
        <v-card v-show="currentCard === 'registerCard'" class="registerCard">
          <div style="height: 24px;">
            <div style="color:rgba(0, 0, 0, 1);font-size: 20px;float: left;line-height: 20px;font-weight: 400;">用户注册</div>
            <div @click="backToAccountLogin" style="cursor: pointer;color:rgba(25, 118, 210, 1);font-size: 16px;float: right;line-height: 24px">返回登录</div>
          </div>
          <div style="width: 283px;margin: 0 auto">
           <v-form class="pt-6"
                   ref="registerForm"
                   v-model="isRegisterMsgValid">
             <v-text-field
                 placeholder="请输入手机账号"
                 v-model="registerPhone"
                 :rules = "phoneRule"
                 @input="onRegisterPhoneChanged"
                 required>
               <template v-slot:message>
                 <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入正确的手机格式</div>
               </template>
               <template v-slot:prepend-inner>
                 <div @click.stop="showPhoneCode = true"  style="cursor: pointer;">
                   <div style="width: fit-content;line-height: 25px;color:black;float: left" >+{{prefix}}</div>
                   <v-icon color="black">mdi-menu-down</v-icon>
                 </div>
               </template>
             </v-text-field>
             <div>
               <div v-show="registerPhoneOccupied" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;该账号已注册</div>
             </div>
           </v-form>
            <v-text-field
                placeholder="请设置密码"
                autocomplete="off"
                v-model="registerPassword"
                :rules="passwordRules"
                :append-icon="showRegisterPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showRegisterPassword ? 'text' : 'password'"
                class="input-group--focused"
                @click:append="showRegisterPassword = !showRegisterPassword">
              <template v-slot:message>
                <div style="padding-top: 1px;padding-right: 1px"><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;密码为6-16个字符，且包含数字和字母及特殊字符</div>
              </template>
            </v-text-field>
            <v-text-field
                placeholder="请重新输入密码"
                autocomplete="off"
                v-model="registerPassword2"
                :rules="password2Rules"
                :append-icon="showRegisterPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showRegisterPassword2 ? 'text' : 'password'"
                class="input-group--focused"
                @click:append="showRegisterPassword2 = !showRegisterPassword2">
              <template v-slot:message>
                <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;两次密码不一致</div>
              </template>
            </v-text-field>
            <input-pic-captcha :prefix="prefix" :phone="registerPhone" :otherShowParam="registerPassword !== '' && registerPassword === registerPassword2">
            </input-pic-captcha>
            <div style="position: relative">
              <v-text-field
                  @input="onRegisterCodeChanged"
                  placeholder="请输入手机验证码"
                  autocomplete="off"
                  v-model="registerVerifyCode"
                  class="input-group--focused"
                  :rules = "requiredRule"
                  border="none">
                <template v-slot:message>
                  <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;验证码不能为空</div>
                </template>
                <template v-slot:append>
                  <div  @click="sendMsg(registerPhone)" style="width: max-content;cursor: pointer;padding-top: 5px;padding-right: 1px" :style="{color:sendingAvailable ?'rgba(25, 118, 210, 1)':'rgba(166, 166, 166, 1)'}">{{sendCodeContent}}</div>
                </template>
              </v-text-field>
              <div>
                <div v-show="loginVerifyCodeLock" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px;text-align:right;" >操作频繁，请1分钟后再试</div>
                <div v-show="registerVerifyCodeError" style="margin-top: -16px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;验证码有误，请重新输入</div>
              </div>
            </div>
            <!--隐私协议-->
            <v-layout row class="ma-0" style="height: 20px;">
              <v-checkbox
                class="mt-0 mr-2"
                style="zoom: 70%;width: 20px;height: 20px;margin-right: 8px"
                v-model="privacyCheckbox">
              </v-checkbox>
              <div style="color:rgba(166, 166, 166, 1);font-size: 13px;line-height: 22px">我已阅读并同意《<span @click="gotoPrivacyAndAgreement('userAgreement')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">服务协议</span>》和《<span @click="gotoPrivacyAndAgreement('privacy')" style="cursor: pointer;color: rgba(25, 118, 210, 1)">隐私条款</span>》</div>
            </v-layout>
            <v-btn
                @click="registerEvent"
                width="283px"
                height="40px"
                depressed
                :color="registerBtnClickable?'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
                style="position:absolute;bottom: 25px;color: white;font-size: 16px">
              注册并登录</v-btn>
          </div>
          <!--区号-->
          <phone-code class="phoneCode" v-show="showPhoneCode" @selectPhoneCode="selectPhoneCode"></phone-code>
        </v-card>
      </div>

    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import Vcode from "vue-puzzle-vcode";
import PhoneCode from "@/components/user_system/PhoneCode";
import InputPicCaptcha from "@/components/user_system/InputPicCaptcha";
import utils from "@/utils/utils";
import axios from "axios";
import router from "@/router";
export default {
  name: "EarthLogin",
  components: {
    PhoneCode,
    Vcode,InputPicCaptcha
  },
  data(){
    return {
      currentCard:"loginCard",
      // currentCard:"registerCard",
      loginWay:"qrCode",
      // loginWay:"account",
      qrHintText:'请使用共生地球APP扫码登录/注册',
      scanSuccess:false,
      // 短信验证码登录
      phoneNum:'',
      prefix:'86',
      showPhoneCode:false,
      countDownClock:null,
      verificationCode:'',
      // 账号密码登录
      loginAccount:"",
      loginPassword:"",
      showLoginPassword:false,
      // 图片验证
      showPicCount:0,
      showPicVerify: false,
      picVerifySuccess:false,
      //绑定扫码成功后前端轮询接口里返回的token
      appToken:'',
      // 注册
      registerPhone:"",
      registerPhoneOccupied:false,
      registerPassword:"",
      registerPassword2:"",
      showRegisterPassword:false,
      showRegisterPassword2:false,
      registerVerifyCode:"",
      ///验证码倒计时
      sendingAvailable:true,
      countDownNum:60,
      sendCodeContent:'获取验证码',

      privacyCheckboxForLogin:false,
      privacyCheckbox:false,
      isLoginMsgValid:true,
      isRegisterMsgValid:true,
      loginVerifyCodeLock:false,
      loginVerifyCodeError:false,
      registerVerifyCodeError:false,
      queryTimer:null,
      isValidTimer:null,
      qrCodeExpired:false,
      loginSuccessToast:true,
      requiredRule:[
        v => !!v || 'E-mail is required',
      ],
      phoneRule:[
        v => (this.prefix === "86" ? v.length === 11 : !!v) || 'phone must be valid',
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules:utils.passwordRules,
      password2Rules:[
        v => !!v || 'Name is required',
        v => (v && v === this.registerPassword ) || "1"
      ],
    }
  },
  computed:{
    phoneLoginBtnClickable(){
      return (this.prefix === "86" ? this.phoneNum.length === 11 : !!this.phoneNum) && this.privacyCheckboxForLogin && !!this.verificationCode
    },
    loginBtnClickable(){
      return !!this.loginAccount && !! this.loginPassword && this.privacyCheckboxForLogin
    },
    registerBtnClickable(){
        return (this.prefix === "86" ? this.registerPhone.length === 11 : !!this.registerPhone) && /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~·！!@#￥$%…^&*（）()\-=—_+[{}【】、|\\；‘：“;’:”,./<>?。《》？-]).{6,16}$/.test(this.registerPassword)  && this.registerPassword === this.registerPassword2 && !!this.registerVerifyCode.length && this.privacyCheckbox === true
    },
    loginPhoneValid(){
      return (this.prefix === "86" ? this.phoneNum.length === 11 : !!this.phoneNum)
    },
    registerPhoneValid(){
      return (this.prefix === "86" ? this.registerPhone.length === 11 : !!this.registerPhone)
    },
  },
  watch:{
    loginPassword(){
      if(this.loginPassword === ''){
        this.loginVerifyCodeError = false
      }
    }
  },
  mounted() {
    if(this.$route.query.currentCard !== undefined){
      this.currentCard = this.$route.query.currentCard
      this.loginWay = this.$route.query.way
    }
    document.addEventListener('click', this.onClickOutside);
    this.qrHintText = "请使用共生地球APP扫码登录/注册";
    this.generateQRCode()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
  methods: {
    onLoginCodeChanged(){
      this.loginVerifyCodeError = false
    },
    onRegisterPhoneChanged(){
      this.registerPhoneOccupied = false
    },
    onRegisterCodeChanged(){
      this.registerVerifyCodeError = false
    },
    onClickOutside(event) {
      let phoneCode = document.querySelector('.phoneCode');
      if (this.showPhoneCode && !phoneCode.contains(event.target)) {
        this.showPhoneCode = false;
      }
    },
    selectPhoneCode(code){
      this.prefix = code
      this.showPhoneCode = false
    },
    async generateQRCode(){
      // 初始化timer
      this.qrCodeExpired = false
      if(this.queryTimer){
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      if(this.isValidTimer){
        clearTimeout(this.isValidTimer)
        this.isValidTimer = null
      }

      // 拉取二维码字符串
      let resultData = await this.$axios.get('/userApi/creator/getQRCode',{
            params:{'purpose':'loginOrRegister'}
          })
      let code = {
        'type':'CodeScanType.loginEarth',
        'content':resultData.data.data
      }
      if(resultData.data.code === 200){
        //清除二维码方法一
        this.$refs.qrCode.innerHTML = '';
        new QRCode(this.$refs.qrCode, {
          //二维码内容
          text: JSON.stringify(code),
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
      if(resultData.data.code === 200){
        // 轮询APP扫码状态
        this.queryTimer = setInterval(() => {
          this.$axios.get('/userApi/creator/checkQRCodeStatusWeb',{
            params:{
              'QRCode':resultData.data.data
            }
          }).then(
              (resultData)=>{
                if(resultData.data.data.status === 1){
                  this.scanSuccess = true
                  this.qrHintText = '请在共生地球APP中进行确认'
                  clearTimeout(this.isValidTimer)
                }else if(resultData.data.data.status === 2){
                  // this.appToken = resultData.data.data.appToken
                  // // 注册绑定
                  // this.currentCard = "registerCard"
                  // this.privacyCheckbox = false
                  // clearTimeout(this.isValidTimer)
                  // clearInterval(this.queryTimer)
                  // this.initQRCodeStatus()
                }else if(resultData.data.data.status === 3){
                  // 直接登录（返回数据已包含登录信息）
                  window.localStorage.setItem('authorToken',resultData.data.token)
                  clearTimeout(this.isValidTimer)
                  clearInterval(this.queryTimer)
                  this.handleLogin(resultData.data.data.user.cardStatus)
                  this.initQRCodeStatus()
                  //埋点
                  this.$utils.eventTracking("工作台_登录_扫码")
                  // this.$router.push({
                  //   path: '/globe',
                  // })
                }
              })
        },1000);
        // 设置5分钟后二维码失效
        this.isValidTimer = window.setInterval(() => {
          clearTimeout(this.isValidTimer)
          clearInterval(this.queryTimer)
          this.isValidTimer = null
          this.qrCodeExpired = true
        }, 60*5*1000)
      }
    },
    initQRCodeStatus(){
      this.qrHintText = "请使用共生地球APP扫码登录/注册";
      this.generateQRCode()
      this.scanSuccess = false
    },
    changeLoginWay(){
      if(this.loginWay ===  "qrCode"){
        clearTimeout(this.isValidTimer)
        clearInterval(this.queryTimer)
        this.loginWay = "verificationCode"
      }else{
        this.loginWay = "qrCode"
        this.showPhoneCode = false
        this.generateQRCode()
      }
    },
    changeLoginWayBottom(){
      if(this.loginWay ===  "verificationCode"){
        this.loginWay = "account"
      }else{
        this.loginWay = "verificationCode"
      }
    },
    async checkPhoneExist(){
      if(!this.phoneLoginBtnClickable){
        return
      }
      this.loginVerifyCodeError = false
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      let resultData = await this.$axios.get('/userApi/existPhone',{
        params:{
          "phone": this.phoneNum,
        }
      })
      return resultData.data.data
    },
    async loginByPhone(){
      if(!this.phoneLoginBtnClickable){
        return
      }
      this.loginVerifyCodeError = false
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      let resultData = await this.$axios.get('/userApi/checkCodeEarth',{
        params:{
          "captcha": this.verificationCode,
          "phone": this.phoneNum,
          "prefix": "+" + this.prefix,
          "device": "web",
          "purpose": "loginOrRegister",
          "site": "earth"
        }
      })
      if(resultData.data.code !== 200){
        this.loginVerifyCodeError = true
        this.showPicCount = this.showPicCount + 1
        this.picVerifySuccess = false
      }else{
        window.localStorage.setItem('authorToken',resultData.data.token)
        this.handleLogin(resultData.data.data.cardStatus)
        //清空图形验证码相关数据
        setTimeout(()=>{
          this.$utils.clearPicCaptchaData();
        },1500)

        //埋点
        //延时调用，为了统计注册来源。如果不延时，下一个接口是earthApi的埋点接口，会认为是在app进行的注册
        setTimeout(()=>{
          this.$utils.eventTracking("工作台_登录_手机验证码")
        },5000)

        // let existPhone = await this.checkPhoneExist()
        // console.log(existPhone)
        // if(existPhone){
        //   this.addPersonalData()
        // }
      }
    },
    addPersonalData(){
      this.$axios.post('/authorApi/personal-data/addPersonalData')
    },
    async loginEvent(){
      if(!this.loginBtnClickable){
        return
      }
      this.loginVerifyCodeError = false
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      let resultData = await this.$axios.get('/userApi/loginEarth',{
        params:{
          'username': this.loginAccount,
          'password': this.loginPassword,
          "site": "earth",
          "device": "phone",
        }
      })
        if(resultData.data.code !== 200){
          this.loginVerifyCodeError = true
          this.showPicCount = this.showPicCount + 1
          this.picVerifySuccess = false
        }else{
          window.localStorage.setItem('authorToken',resultData.data.token)
          this.handleLogin(resultData.data.data.cardStatus)
          //埋点
          this.$utils.eventTracking("工作台_登录_账号密码")
        }

    },
    handleLogin(cardStatus){
      //cardStatus为1用户已进行实名认证
      console.log("实名认证")
      console.log(cardStatus)

      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "登录成功"
      this.$store.state.snackbarType = 'success'

      let _this = this
      setTimeout(function(){
        if(cardStatus === 1){
          //已经实名认证
          if(_this.$route.query.goBack === 'true' ){
            _this.$router.back()
          }else{
            _this.$router.push({
              path: '/globe',
            })
          }
        }
        else{
          //没有实名认证
          _this.$router.push({
            path: '/realNameAuth',
          })
        }
      },1000)

    },
    registerEvent(){
      if(!this.registerBtnClickable){
        return;
      }
      if(this.showPicCount >= 3 && !this.picVerifySuccess){
        this.showPicVerify = true
        return
      }
      this.registerVerifyCodeError = false
      this.registerPhoneOccupied = false
      let formData = new FormData();
      formData.append('prefix',this.prefix);
      formData.append('phone',this.registerPhone);
      formData.append('password',this.registerPassword);
      formData.append('captcha',this.registerVerifyCode);
      this.$axios.post('/authorApi/personal-data/registerUser',formData)
          .then((resultData)=>{
            if(resultData.data.status === 200){
              window.localStorage.setItem('authorToken',resultData.data.data.token)
              this.handleLogin(resultData.data.data.cardStatus)
              //清空图形验证码相关数据
              setTimeout(()=>{
                this.$utils.clearPicCaptchaData();
              },1500)
            }else if(resultData.data.status === 4009){
              this.registerPhoneOccupied = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }else{
              this.registerVerifyCodeError = true
              this.showPicCount = this.showPicCount + 1
              this.picVerifySuccess = false
            }
          })
    },
    // 用户通过了验证
    onPicVerifySuccess(msg) {
      this.showPicVerify = false;
      this.showPicCount = 2
      this.picVerifySuccess = true
      // 通过验证后，需要手动隐藏模态框
    },
    // 用户点击遮罩层，应该关闭模态框
    closePicVerify() {
      this.showPicVerify = false;
    },
    backToAccountLogin(){
      this.currentCard = "loginCard"
      this.loginWay = "account"
    },

    sendMsg(phoneNum){
      if(!this.sendingAvailable){
        return
      }
      if(!(this.prefix === "86" ? phoneNum.length === 11 : !!phoneNum)){
        if(this.currentCard === 'loginCard'){
          this.$refs.phoneLoginForm.validate()
        }else {
          this.$refs.registerForm.validate()
        }
        return;
      }
      if(this.$store.state.picCaptcha === ""){
        this.$store.state.picCaptchaError = true;
        return;
      }
      let formData = new FormData()
      formData.append('phone',phoneNum)
      formData.append('prefix',"+" + this.prefix)
      formData.append('picCaptcha',this.$store.state.picCaptcha)
      formData.append( 'purpose','loginOrRegister')
      this.$axios.post('/userApi/sendCodeForAction',formData).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.code === 4015){
          this.$store.state.picCaptchaError = true;
        }
        else if(resultData.code === 4014){
          this.loginVerifyCodeLock = true;
          setTimeout(()=>{
            this.loginVerifyCodeLock = false;
          },3000)
        }
        else{
          this.sendingAvailable = false
          this.countDownClock = window.setInterval(() => {
            this.countDownNum--;
            this.sendCodeContent = "重新发送（"+this.countDownNum+')'
            if (this.countDownNum < 0) {
              //当倒计时小于0时清除定时器
              window.clearInterval(this.countDownClock); //关闭
              this.sendingAvailable = true;
              this.countDownNum = 60;
              this.sendCodeContent = "获取验证码"
            }
          }, 1000);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    validateRegisterForm () {
      return  this.$refs.registerForm.validate()
    },
    validateLoginForm () {
      return  this.$refs.loginForm.validate()
    },
    validatePhoneLoginForm () {
      return  this.$refs.phoneLoginForm.validate()
    },
    goToRegister(){
      this.currentCard = "registerCard"
      //发送验证码清零
      window.clearInterval(this.countDownClock); //关闭
      this.sendingAvailable = true;
      this.countDownNum = 60;
      this.sendCodeContent = "获取验证码"
      this.privacyCheckbox = false
    },
    gotoRetrievePassword(){
      this.$router.push({
        name: 'retrievePassword',
      })
    },
    gotoPrivacyAndAgreement(type){
     let path = this.$router.resolve({
       path: '/documentPage',query:{
          pageType:type
        }
      })
      window.open(path.href,'_blank')
    },
  }
}
</script>

<style scoped>

  .card{
    padding:40px 45px 0px 45px;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .registerCard{
    padding:40px 60px 10px 60px;
    width: 100%;
    height: 100%
  }
  /*各浏览器提示文本样式*/
  input::-webkit-input-placeholder { /* WebKit browsers */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  input:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: rgba(166, 166, 166, 1);
    font-size: 16px;
    line-height: 22px;  }
  .bottom_border{
    width: 283px;
    height: 1px;
    background-color: rgba(229, 229, 229, 1);
  }
</style>
